// Core
import React, { ReactElement } from 'react';
// Instruments
import styles from './styles.module.css';
import { PropTypes } from './types';

export const Title = ({ title }: PropTypes): ReactElement => (
  <div className={styles.sub_title}>{title && title}</div>
);
